<div class="flex flex-wrap overflow-hidden bg-primary m-0 mb-2">
    <div class="flex-1 md:flex-none bg-white p-2">
      <img src="assets/images/logo.png" />
    </div>
    <div class="flex-grow-1 text-2xl font-semibold p-2 md:p-4">
      {{ title }}
    </div>
  </div>